import React from 'react';

const PrivacyPolicyPage = () => {
  return (
    <div className="public-website">
      <div className="container">
        <h1>Privacy Policy Page</h1>
        <p>Privacy policy page coming soon...</p>
      </div>
    </div>
  );
};

export default PrivacyPolicyPage; 